import { render, staticRenderFns } from "./Gip.vue?vue&type=template&id=51c5efc9"
import script from "./Gip.vue?vue&type=script&lang=js"
export * from "./Gip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports